import { ApplicationDto } from './ApplicationDto';
import { GetRolesForApplicationDto } from './GetRolesForApplicationDto';

export class RoleManagementPreload extends GetRolesForApplicationDto {
  applications: Array<ApplicationDto>;
}
